import React, { Component } from 'react'; 
import {Row, Col, Table} from 'react-bootstrap';
import _ from "lodash";
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS
import ClientData from './ClientData'

class RegionalData extends Component {
  constructor(props){
  super(props)
    this.state={
      data : props.data
    }
  }
  
  handleCallBackFunction = (index, prop) => {    
    let tempdata = _.cloneDeep(this.state.data)
    tempdata.clientCenters[index] = prop
    this.setState({data:tempdata})    
    this.props.onFunction(tempdata)
  }
  
  centerBody = () => {
    const{data} = this.props
    let UI = _.map(data.clientCenters, (obj, inde)=>{
       return(
       <ClientData onCallBackFunction={(a)=>this.handleCallBackFunction(inde, a)}
        centerData={obj} reportlist={this.props.reportlist} freqlist={this.props.freqlist}
        />
     )
    })
    return UI;
  }
  
  render(){
    const{data} = this.props;
    return(
      <div >       
        <Row>
           <Col md={4}>Region Name</Col>
           <Col md={6}>
            <Picky keepOpen={false}
              value={data.inventoryRegionName}
              //options={payload.regions}
              //onChange={this.handleRegions}
              open={false}
              valueKey="label"
              labelKey="label"
              multiple={false}
              includeSelectAll={true}
              includeFilter={false}
              placeholder='Select Regions'
              dropdownHeight={600}
              disabled
            /></Col>
           <Col md={2}></Col>
        </Row>
           <Table responsive className="noalternate">
            <thead>
            <th>SELECT CENTER</th>            
            <th>PROCESS NAME</th>
            <th>LOGO</th>
            <th>CONTACT PERSON NAME</th>
            <th>CONTACT PERSON NUMBER</th>
            <th>CONTACT PERSON EMAIL</th>            
            <th>REPORTS & FREQUENCY</th>            
            <th></th>
            </thead>
            <tbody>
          {this.centerBody()}</tbody> 
          </Table>
        
      </div>
      );
  }

}

export default RegionalData

